import { Animate } from "components/lib";
import styles from "./styles.module.scss";

export function Support(props) {
  return (
    <Animate type="pop">
      {/*       <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div
          className={styles.container}
          style={{ marginBottom: 40, marginTop: 10 }}
        >
          <h1
            style={{
              maxWidth: 800,
              textAlign: "center",
              fontSize: 20,
              fontWeight: 600,
            }}
          >
            We want to make our plataform perfect, so we would love to hear from
            you on feedback to make it better and or current issues. Please fill
            out the appropriate form or email us at Hello@CoverBadger.com
          </h1>
        </div>
        <div className={styles.container}>
          <div className={styles.wrapper}>
            <h1>Feedback to improve the platform</h1>
            <Formik
              validationSchema={validationSchema}
              enableReinitialize
              initialValues={{
                name: "",
                email: "",
                message: "",
              }}
              onSubmit={async (values) => {
                setLoadingFeedback(true);

                await axios
                  .post("/api/user/message", {
                    type: "feedback",
                    name: values.name,
                    email: values.email,
                    message: values.message,
                  })
                  .then((r) => {
                    setLoadingFeedback(false);

                    context.notification.show(
                      "Feedback sent.",
                      "success",
                      true,
                      "toast",
                      "x-circle"
                    );
                  })
                  .catch((err) => {
                    setLoadingFeedback(false);

                    console.log(err);

                    context.notification.show(
                      "Failed on send feedback message, try again later.",
                      "error",
                      true,
                      "toast",
                      "x-circle"
                    );
                  });
              }}
            >
              {({
                errors,
                touched,
                handleSubmit,
                handleChange,
                handleBlur,
                submitForm,
              }) => (
                <Fragment>
                  <Form className={styles.form} onSubmit={handleSubmit}>
                    <div className={styles.fieldRow} style={{ marginTop: 10 }}>
                      <FieldInput
                        id="name"
                        type="text"
                        label="Name"
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        showErrors
                        errors={errors.name}
                        touched={touched.name}
                      />
                    </div>

                    <div className={styles.fieldRow} style={{ marginTop: 10 }}>
                      <FieldInput
                        id="email"
                        type="text"
                        label="Email"
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        showErrors
                        errors={errors.email}
                        touched={touched.email}
                      />
                    </div>
                    <div className={styles.fieldRow} style={{ marginTop: 10 }}>
                      <FieldInput
                        id="message"
                        type="area"
                        label="Feedback"
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        showErrors
                        errors={errors.message}
                        touched={touched.message}
                      />
                    </div>
                  </Form>
                  <div className={styles.footer}>
                    <div className={styles.buttons}>
                      <button
                        className={styles.save}
                        style={
                          !loadingFeedback
                            ? { cursor: "pointer" }
                            : { cursor: "default" }
                        }
                        onClick={!loadingFeedback ? submitForm : null}
                      >
                        {loadingFeedback ? (
                          <img
                            src={image}
                            alt="loading"
                            style={{ width: "25px" }}
                          />
                        ) : (
                          "Send"
                        )}
                      </button>
                    </div>
                  </div>
                </Fragment>
              )}
            </Formik>
          </div>
          <div className={styles.wrapper}>
            <h1>Current issue with the platform</h1>
            <Formik
              validationSchema={validationSchema}
              enableReinitialize
              initialValues={{
                name: "",
                email: "",
                message: "",
              }}
              onSubmit={async (values) => {
                setLoadingCurrentIssue(true);

                await axios
                  .post("/api/user/message", {
                    type: "issue",
                    name: values.name,
                    email: values.email,
                    message: values.message,
                  })
                  .then((r) => {
                    setLoadingCurrentIssue(false);

                    context.notification.show(
                      "Issue sent.",
                      "success",
                      true,
                      "toast",
                      "x-circle"
                    );
                  })
                  .catch((err) => {
                    setLoadingCurrentIssue(false);

                    console.log(err);

                    context.notification.show(
                      "Failed on send support message, try again later.",
                      "error",
                      true,
                      "toast",
                      "x-circle"
                    );
                  });
              }}
            >
              {({
                errors,
                touched,
                handleSubmit,
                handleChange,
                handleBlur,
                submitForm,
              }) => (
                <Fragment>
                  <Form className={styles.form} onSubmit={handleSubmit}>
                    <div className={styles.fieldRow} style={{ marginTop: 10 }}>
                      <FieldInput
                        id="name"
                        type="text"
                        label="Name"
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        showErrors
                        errors={errors.name}
                        touched={touched.name}
                      />
                    </div>

                    <div className={styles.fieldRow} style={{ marginTop: 10 }}>
                      <FieldInput
                        id="email"
                        type="text"
                        label="Email"
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        showErrors
                        errors={errors.email}
                        touched={touched.email}
                      />
                    </div>
                    <div className={styles.fieldRow} style={{ marginTop: 10 }}>
                      <FieldInput
                        id="message"
                        type="area"
                        label="Current issue"
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        showErrors
                        errors={errors.message}
                        touched={touched.message}
                      />
                    </div>
                  </Form>
                  <div className={styles.footer}>
                    <div className={styles.buttons}>
                      <button
                        className={styles.save}
                        style={
                          !loadingCurrentIssue
                            ? { cursor: "pointer" }
                            : { cursor: "default" }
                        }
                        onClick={!loadingCurrentIssue ? submitForm : null}
                      >
                        {loadingCurrentIssue ? (
                          <img
                            src={image}
                            alt="loading"
                            style={{ width: "25px" }}
                          />
                        ) : (
                          "Send"
                        )}
                      </button>
                    </div>
                  </div>
                </Fragment>
              )}
            </Formik>
          </div>
        </div>
      </div> */}
      <div className={styles.iframe_container}>
        <iframe src="https://help.coverbadger.com" />
      </div>
    </Animate>
  );
}
